module.exports = __webpack_public_path__ + "media/images/png/check-3b701dc1bc19be4cd9780093759bfb80.png";